import {
  Children,
  Component,
  Fragment,
  type ReactElement,
  type ReactNode,
} from 'react'

class DynamicFilters extends Component<ComponentProps, ComponentState> {
  state = this.getInitialState()
  readonly #container: string | typeof Fragment

  constructor(props: ComponentProps) {
    super(props)

    this.#container = this.props.className ? 'div' : Fragment
  }

  getInitialState() {
    const { order = [] } = this.props
    const orderedIndexes = Object.fromEntries(
      order.map((val, index) => [val, index + 1])
    )

    return { orderedIndexes }
  }

  sortByIndex(a: Attribute, b: Attribute): number {
    const { orderedIndexes } = this.state

    // Items either have no sorting or it is just one of them
    if (orderedIndexes[a] === orderedIndexes[b]) return 0
    if (!orderedIndexes[a]) return 1
    if (!orderedIndexes[b]) return -1

    // Both items have sorting order
    return orderedIndexes[a] > orderedIndexes[b] ? 1 : -1
  }

  sortChildren(filters: ReactElement[]) {
    filters.sort((child1, child2) =>
      this.sortByIndex(
        child1.props.attribute || child1.props['data-attribute'],
        child2.props.attribute || child2.props['data-attribute']
      )
    )
  }

  render(): ReactNode {
    const { children, className } = this.props
    const filters = Children.toArray(children) as ReactElement[]
    const Container = this.#container

    this.sortChildren(filters)

    //@ts-ignore TSC cannot infer the correct type, see constructor: no illegal props passed
    return <Container className={className}>{filters}</Container>
  }
}

type Attribute = string | number

type ComponentProps = {
  children: ReactElement[]
  order: Attribute[]
  className?: string
}

type ComponentState = {
  orderedIndexes: Record<Attribute, number>
}

export default DynamicFilters
